import { api } from "./axios";
import { makeFilterString } from './utils';

export async function getAllRate(objFilter) {
    let res = await api.get("rate/" + makeFilterString(objFilter));
    if (res) return res.data.data;
    else return false;
}

export async function getAllRateByFilter(body, objFilter) {
    let res = await api.post("rate/rate_filter/" + makeFilterString(objFilter), body);
    if (res) return res.data.data;
    else return false;
}

export async function changeStatusRate(id, status) {
    let res = await api.get("rate/status/" + id + '/' + status);
    if (res) return res.data.data;
    else return false;
}

export async function deleteRate(id) {
    let res = await api.get("rate/destroy/" + id);
    if (res) return res.data.data;
    else return false;
}
